
import Vue from 'vue'

export default Vue.extend({
  name: 'SmallArrowSvg',
  props: {
    color: {
      required: false,
      default: 'currentColor',
      type: String,
    },
  },
})
